import React, { Component } from 'react';
//import { Route } from 'react-router-dom';
import style from './Template.module.css';
import MenuLeftV2 from './MenuLeftV2.js';
//import * as utils from './Utils.js';
import HopInnHeader from './HopInnHeader.js';


class TemplateV2 extends Component {
    constructor(props) {
        super(props);   
        this.state = {
        
        };
    }
    render(){

        if(this.props.appState.userObject !== null){
            return(
                <div className={style.main}>
                    <HopInnHeader appState={this.props.appState} />
    
    
                    <div className={style.content}>
                                <div className={style.areaLeft}>
                                    <MenuLeftV2 site={this.props.site} page={this.props.page} appState={this.props.appState}/>
                                </div>
                                <div className={style.areaRight}>
    
    
    
                                {this.props.children}
    
    
    
                                   
                                </div>
                            </div>
    
    
    
                    
                </div>
            );
        }
        else{
            return(<></>);
        }

        
    }
}
export default TemplateV2
